import {addEvent} from "../../utils/events/events";
import {onReady} from "../../utils/events/onReady";
import {Loader} from "@googlemaps/js-api-loader";
import {forEach} from "../../utils/forEach";

export class Map {
    /**
     * Internal placeholder for DOM-objects
     *
     * @type {object}
     * @ignore
     */
    dom = {
        container: undefined
    };

    /**
     *
     * @param {Element} domReference - The element to work from
     */
    constructor(domReference) {
        this.dom.container = domReference;
        this.map = "";
        this.loader = new Loader({
            apiKey: "AIzaSyAAEQ1evP_ReoYlV_rOT1MgXXGz4uEdv-U",
            version: "weekly"
        });

        onReady(() => this.init(domReference));
    }

    openDropdown(e) {
        if (e.target.classList.contains("is-visible")) {
            const currentItem = e.target;
            const parentItem = e.target.parentNode;
            const ariaValue = JSON.parse(
                parentItem.children[1].getAttribute("aria-expanded")
            );
            currentItem.classList.toggle("is-open");
            parentItem.children[1].setAttribute("aria-expanded", !ariaValue);
        }
    }

    panMapTo(latlng, map) {
        map.panTo(latlng);
        map.setZoom(14);
    }

    selectDepartment(e) {
        if (!e.target.classList.contains("is-visible")) {
            const departmentId = e.target.id;
            this.dom.container
                .querySelectorAll(".map__departament--data")
                .forEach(item => {
                    if (departmentId === item.dataset.id) {
                        const containerBottom = document.querySelector(
                            ".map__info--container--bottom"
                        );
                        containerBottom.innerHTML = "";
                        const listContainer = document.querySelector(
                            ".dropdown__map--list"
                        );
                        listContainer.setAttribute("aria-expanded", false);
                        const address =
                            item.querySelector("[data-address]").dataset
                                .address;
                        const city =
                            item.querySelector("[data-city]").dataset.city;
                        const postnumber =
                            item.querySelector("[data-postnumber]").dataset
                                .postnumber;
                        const openinghours = item.querySelector(
                            "[data-openinghours]"
                        ).dataset.openinghours;
                        const noopeninghours = item.querySelector(
                            "[data-noopeninghours]"
                        ).dataset.noopeninghours;
                        let phone =
                            item.querySelector("[data-phone]").dataset.phone;



                        if (
                            item.querySelector("[data-lat]") &&
                            item.querySelector("[data-long]")
                        ) {
                            const latlng = {
                                lat: Number(
                                    item.querySelector("[data-long]").dataset
                                        .long
                                ),
                                lng: Number(
                                    item.querySelector("[data-lat]").dataset.lat
                                )
                            };

                            this.panMapTo(latlng, this.map);
                        }
                        let phoneHtml = "";

                        if (phone !== "0") { phoneHtml = `
                            <div class="map__info--phonenumber">
                                <p class="map__info--container--phone"> Telefon: ${phone}</p>
                            </div>`;
                        }
                        console.log(phone, "should show", phone !== "0");

                        containerBottom.innerHTML = `
                        <div  class="map__info--container-department">
                            <div class="map__info--address">
                                <p class="map__info--container--headline">Adresse</p>
                                    <p>${address}</p>
                                <span><p>${postnumber} ${city}</p></span>
                            </div>
                            <div class="map__info--openinghours">
                                    <p>${openinghours}</p>
                                    <p>${noopeninghours}</p>
                            </div>
                            ${phoneHtml}
                        </div>
                    `;
                    }
                });
            this.dom.container
                .querySelectorAll(".dropdown__map--item")
                .forEach(item => {
                    item.setAttribute("aria-hidden", "true");
                });
            this.dom.container.querySelector(
                ".dropdown__map--item.is-visible"
            ).textContent = e.target.textContent;
            this.dom.container
                .querySelector(".dropdown__map--item.is-visible")
                .setAttribute("aria-hidden", "false");
            this.dom.container
                .querySelector(".dropdown__map--item.is-visible")
                .classList.remove("is-open");
        }
    }

    loadMap() {
        const loader = new Loader({
            apiKey: "AIzaSyAAEQ1evP_ReoYlV_rOT1MgXXGz4uEdv-U",
            version: "weekly"
        });

        loader.load().then(() => {
            this.map = new google.maps.Map(document.getElementById("map"), {
                center: {lat: 56.2639, lng: 9.5018},
                zoom: 7,
                zoomControl: false,
                mapTypeControl: false,
                scaleControl: false,
                streetViewControl: false,
                rotateControl: false,
                fullscreenControl: false
            });

            let infowindow = new google.maps.InfoWindow({
                content: "",
                maxWidth: 550
            });

            this.dom.container
                .querySelectorAll(".map__departament--data")
                .forEach(bank => {

                    let phoneHtml = "";
                    let phone = bank.querySelector("[data-phone]").dataset.phone;
                    console.log(phone, "should show", phone !== "0");
                    if (phone !== "0") {
                        phoneHtml = `    <p style="margin: 0.5rem 0"><b>Telefon: </b>${
                            phone
                        } </p>`;
                    }

                    const popupInformation = `
                    <div style="padding: .5rem">
                    <h3 style="margin: 0.5rem 0">${
                        bank.querySelector("[data-name]").dataset.name
                    }</h3>
                    <p style="margin: 0.5rem 0"><b>Adresse:</b></p>
                    <p style="margin: 0.5rem 0">${
                        bank.querySelector("[data-address]").dataset.address
                    } </p>
                    <p style="margin: 0.5rem 0"> ${
                        bank.querySelector("[data-postnumber]").dataset
                            .postnumber
                    }

                    ${bank.querySelector("[data-city]").dataset.city}
                    </p>

                    <p style="margin: 0.5rem 0">${
                        bank.querySelector("[data-openinghours]").dataset
                            .openinghours
                    } </p>
                    <p style="margin: 0.5rem 0">${
                        bank.querySelector("[data-noopeninghours]").dataset
                            .noopeninghours
                    } </p>
                    ${phoneHtml}
                <p style="margin: 0.5rem 0">
                    </div>
                `;
                    const markerImage =
                        "https://prod-andelskassen-dk.azurewebsites.net/media/xlygek0s/marker.png";

                    if (
                        bank.querySelector("[data-lat]") &&
                        bank.querySelector("[data-long]")
                    ) {
                        const marker = new google.maps.Marker({
                            position: {
                                lat: Number(
                                    bank.querySelector("[data-long]").dataset
                                        .long
                                ),
                                lng: Number(
                                    bank.querySelector("[data-lat]").dataset.lat
                                )
                            },
                            map: this.map,
                            title: bank.querySelector("[data-city]").dataset
                                .city,
                            icon: markerImage
                        });
                        marker.addListener("click", function () {
                            infowindow.setContent(popupInformation);
                            infowindow.open({
                                anchor: marker,
                                map: this.map,
                                shouldFocus: false
                            });
                        });
                    }
                });
        });
    }

    init(domReference) {
        const dropdownButton = domReference.querySelector(
            ".dropdown__map--item.is-visible"
        );
        addEvent(dropdownButton, "click", e => {
            this.openDropdown(e);
        });
        const dropdownItems = domReference.querySelectorAll(
            ".dropdown__map--item"
        );
        dropdownItems.forEach(item => {
            addEvent(item, "click", e => {
                this.selectDepartment(e);
            });
        });
        this.loadMap();
    }
}
